// extracted by mini-css-extract-plugin
export default {"root":"yFTTGlCox2cWNUAgRJlC","name":"ICtm9HUDuT8VCQaA7X6b","overflow-wrapper":"tP9dKL3hOY2ww2mLM_FL","overflowWrapper":"tP9dKL3hOY2ww2mLM_FL"};